//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'qrCoupon',
  components: {
    
  },
  data () {
    return {
      popUp:false,
      dateStatus:false,
      size:250,
      days:'',
      qrcode:'',
      endDate:'',
      number:'',
      id:0,
      info:{
        coupon:{}
      },
    }
  },
  created() {
    this.id = Number(this.$route.params.id);
    this.communityCoupon();
  },
  methods:{
    communityCoupon(){
      this.$api.communityCoupon({id:this.id}).then((res)=>{
        if(res){
          this.info = res.data;
        } 
      })  
    },
    submit(){
      if(this.number <= 0){
        this.$func.showToast('请输入领取数量');
        return false;
      }
      this.$api.subQrCoupon({id:this.id,number:this.number,days:this.days}).then((res)=>{
        if(res){
          this.qrcode = res.data.path;
          console.log('qrcode',res.data.path);
          this.popUp = true;
        }
      })  
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/qrCoupon.vue